module.exports = __webpack_public_path__ + "img/serigrafia_negro.9199bb9a.jpg";